import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default, { useContext } from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';
import { FlexGridContext } from './FlexGridContext.js';

var StyledBox = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Row__StyledBox",
  componentId: "sc-1ohbymv-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  :first-of-type {\n    margin-top: 0;\n  }\n"], ["\n  :first-of-type {\n    margin-top: 0;\n  }\n"])));
var Row = function (_a) {
  var children = _a.children,
    rest = __rest(_a, ["children"]);
  var gutter = useContext(FlexGridContext).gutter;
  var gutterCompensation = Array.isArray(gutter) ? gutter.map(function (v) {
    return -v;
  }) : -(gutter || 0);
  return React__default.createElement(StyledBox, __assign({
    display: "flex",
    flex: "0 1 auto",
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: gutter,
    marginBottom: gutterCompensation,
    marginRight: gutterCompensation
  }, rest), children);
};
var templateObject_1;

export { Row };
//# sourceMappingURL=Row.js.map
